module.exports = __webpack_public_path__ + "img/diu-logo-big.21f3a1b5.png";